import { render, staticRenderFns } from "./CobrarCheque.vue?vue&type=template&id=2aeb3442&"
import script from "./CobrarCheque.vue?vue&type=script&lang=js&"
export * from "./CobrarCheque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports